import {useMemo} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandHandclapIcon} from "@pg-design/icons-module";
import {Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {appendQueryString} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";

import {buildFriendlyOfferListLink} from "../../../offer/helpers/friendly_offer_list/build_friendly_offer_list_link";
import {useGetRegionDetailQuery} from "../../../region/api/get_region_detail";
import {useAppSelector} from "../../../store/hooks";
import {ViewType} from "../../../view_type/ViewType";

interface IProps {
    isOpen: boolean;
    onClose?: () => void;
}

export const RegistrationThankYouModal = (props: IProps) => {
    const {isOpen, onClose} = props;
    const {isMobile} = useUserDevice();
    const preferences = useAppSelector((state) => state.registrationFlow.preferences);
    const currentViewType = useAppSelector((state) => state.viewType.current);

    const isSingleRegion = preferences?.regions.length === 1;
    const singleRegionId = useMemo(() => (isSingleRegion ? preferences?.regions[0] : undefined), [preferences, isSingleRegion]);
    const {data: singleRegionDetail, isLoading: isSingleRegionLoading} = useGetRegionDetailQuery({regionId: singleRegionId!}, {skip: !singleRegionId});

    const handleClose = () => {
        onClose?.();
    };

    const handleRedirect = () => {
        if (preferences) {
            const hasRegions = preferences.regions.length > 0;
            const hasMultipleRegions = preferences.regions.length > 1;

            const baseQuery = {
                rooms_0: preferences.rooms.lower,
                rooms_1: preferences.rooms.upper,
                ...(preferences.price ? {price_1: preferences.price} : {})
            };

            const redirectUrl =
                !hasRegions || hasMultipleRegions
                    ? appendQueryString(rpAppLink.offer.multiList(), {
                          ...baseQuery,
                          ...(hasRegions ? {region: preferences.regions.map((r) => r.toString())} : {})
                      })
                    : buildFriendlyOfferListLink({
                          ...baseQuery,
                          region: singleRegionDetail?.slug || ""
                      });

            window.location.href = redirectUrl;
        }

        onClose?.();
    };

    const shouldPricesButtonRedirectToListing = [ViewType.HOMEPAGE].includes(currentViewType as ViewType);

    return (
        <Modal isOpen={isOpen} onModalClose={handleClose}>
            <Modal.Layout.EmptyResponsive closeButtonVariant="rounded" className={modalStyle}>
                <div className={contentStyle}>
                    <BrandHandclapIcon size={isMobile ? "10.0" : "19"} wrapperSize={isMobile ? "10.0" : "19"} wrapperColor="var(--colors-primary)" />

                    <Text variant="headline_2" align="center" className={titleStyle}>
                        Wszystkie ceny na portalu są już widoczne!
                    </Text>

                    <Text variant="body_copy_0" align="center" className={descriptionStyle}>
                        Więcej informacji o interesujących Cię nieruchomościach otrzymasz od dewelopera w ciągu 48 godzin.
                    </Text>

                    <Button
                        variant="filled_primary"
                        onClick={shouldPricesButtonRedirectToListing ? handleRedirect : handleClose}
                        className={buttonStyle}
                        isLoading={isSingleRegionLoading}
                    >
                        ZOBACZ CENY
                    </Button>
                </div>
            </Modal.Layout.EmptyResponsive>
        </Modal>
    );
};

const modalStyle = css({
    maxWidth: "840px",
    p: 4
});

const contentStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 3,
    py: 4,
    md: {
        minWidth: "70rem"
    }
});

const titleStyle = css({
    maxWidth: "60rem"
});

const descriptionStyle = css({
    maxWidth: "70rem"
});

const buttonStyle = css({
    mt: 2,
    width: "100%",
    minWidth: "26rem",
    md: {
        width: "auto"
    }
});
import {useMemo} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandHandclapIcon} from "@pg-design/icons-module";
import {Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {appendQueryString} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";
import {useUserDevice} from "@pg-mono/user-device";

import {buildFriendlyOfferListLink} from "../../../offer/helpers/friendly_offer_list/build_friendly_offer_list_link";
import {useGetRegionDetailQuery} from "../../../region/api/get_region_detail";
import {useAppSelector} from "../../../store/hooks";
import {ViewType} from "../../../view_type/ViewType";

interface IProps {
    isOpen: boolean;
    onClose?: () => void;
}

export const RegistrationThankYouModal = (props: IProps) => {
    const {isOpen, onClose} = props;
    const {isMobile} = useUserDevice();
    const preferences = useAppSelector((state) => state.registrationFlow.preferences);
    const currentViewType = useAppSelector((state) => state.viewType.current);

    const isSingleRegion = preferences?.regions.length === 1;
    const singleRegionId = useMemo(() => (isSingleRegion ? preferences?.regions[0] : undefined), [preferences, isSingleRegion]);
    const {data: singleRegionDetail, isLoading: isSingleRegionLoading} = useGetRegionDetailQuery({regionId: singleRegionId!}, {skip: !singleRegionId});

    const handleClose = () => {
        onClose?.();
    };

    const handleRedirect = () => {
        if (preferences) {
            const hasRegions = preferences.regions.length > 0;
            const hasMultipleRegions = preferences.regions.length > 1;

            const baseQuery = {
                rooms_0: preferences.rooms.lower,
                rooms_1: preferences.rooms.upper,
                ...(preferences.price ? {price_1: preferences.price} : {})
            };

            const redirectUrl =
                !hasRegions || hasMultipleRegions
                    ? appendQueryString(rpAppLink.offer.multiList(), {
                          ...baseQuery,
                          ...(hasRegions ? {region: preferences.regions.map((r) => r.toString())} : {})
                      })
                    : buildFriendlyOfferListLink({
                          ...baseQuery,
                          region: singleRegionDetail?.slug || ""
                      });

            window.location.href = redirectUrl;
        }

        onClose?.();
    };

    const shouldPricesButtonRedirectToListing = [ViewType.HOMEPAGE].includes(currentViewType as ViewType);

    return (
        <Modal isOpen={isOpen} onModalClose={handleClose}>
            <Modal.Layout.EmptyResponsive closeButtonVariant="rounded" className={modalStyle}>
                <div className={contentStyle}>
                    <BrandHandclapIcon size={isMobile ? "10.0" : "19"} wrapperSize={isMobile ? "10.0" : "19"} wrapperColor="var(--colors-primary)" />

                    <Text variant="headline_2" align="center" className={titleStyle}>
                        Wszystkie ceny na portalu są już widoczne!
                    </Text>

                    <Text variant="body_copy_0" align="center" className={descriptionStyle}>
                        Więcej informacji o interesujących Cię nieruchomościach otrzymasz od dewelopera w ciągu 48 godzin.
                    </Text>

                    <Button
                        variant="filled_primary"
                        onClick={shouldPricesButtonRedirectToListing ? handleRedirect : handleClose}
                        className={buttonStyle}
                        isLoading={isSingleRegionLoading}
                    >
                        ZOBACZ CENY
                    </Button>
                </div>
            </Modal.Layout.EmptyResponsive>
        </Modal>
    );
};

const modalStyle = css({
    maxWidth: "840px",
    p: 4
});

const contentStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 3,
    py: 4,
    md: {
        minWidth: "70rem"
    }
});

const titleStyle = css({
    maxWidth: "60rem"
});

const descriptionStyle = css({
    maxWidth: "70rem"
});

const buttonStyle = css({
    mt: 2,
    width: "100%",
    minWidth: "26rem",
    md: {
        width: "auto"
    }
});
